<template>
  <div class="container">
    <div class="selectconditons">
      <a-input
        ref="templeCode"
        v-model="inputGroup.templeCode"
        placeholder="模板编码"
        style="width: 15%; margin-right: 2%"
        @pressEnter=";(pagination.current = 1), getTableDateNew()"
      >
        <a-icon slot="prefix" type="mobile" />
        <a-tooltip slot="suffix" title="要模板ID">
          <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
        </a-tooltip> </a-input
      >短信来源：
      <a-select style="width: 14%; margin-right: 1%" @select="sourceChooseWhat" show-search placeholder="短信来源">
        <a-select-option :value="value.sources" v-for="value in sourceOpenion" :key="value.id">{{
          value.sources
        }}</a-select-option>
      </a-select>
      <a-input
        ref="sources"
        v-model="inputGroup.messagecontent"
        placeholder="模板内容"
        style="width: 15%; margin-right: 2%"
        @pressEnter=";(pagination.current = 1), getTableDateNew()"
      >
        <a-icon slot="prefix" type="mail" />
        <a-tooltip slot="suffix" title="模糊查询模板内容">
          <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
        </a-tooltip> </a-input
      >短信类型：
      <a-select
        show-search
        style="width: 14%; margin-right: 1%"
        @select="chooseWhat"
        @focus="getMessageTypeOpenion()"
        placeholder="短信类型"
      >
        <a-select-option :value="value" v-for="value in messageType" :key="value.index">{{ value }}</a-select-option>
      </a-select>
      <a-button type="primary" icon="search" @click=";(pagination.current = 1), getTableDateNew()">搜索</a-button>
      <a-button type="primary" icon="plus" style="margin-left: 1%" @click="visible = true">添加模板</a-button>
    </div>

    <a-drawer
      title="模板信息"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      :maskClosable="false"
      width="50%"
    >
      <add-message-temple @addTemple="addTempleResult" :templte="templte"></add-message-temple>
    </a-drawer>
    <div class="selectresulttable">
      <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" bordered>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="testRecord(record)" size="small" style="margin-right: 3px">修改</a-button>
        </span>
      </a-table>
      <div class="pageBar">
        <a-pagination
          size="small"
          style="margin-top: 1%; float: right"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
  </div>
</template>


<script>
import { getMessageInfo, getMessageType, getSourcesSelecetOpion } from '@/api/api'
import moment from 'moment'
import AddMessageTemple from './components/addMessageTemple'
//表格字段名称
const columns = [
  {
    title: '模板号',
    dataIndex: 'tempCode',
    key: 'tempCode',
    width: 80,
    align: 'center',
  },
  {
    title: '模板名',
    dataIndex: 'tempName',
    key: 'tempName',
    width: 100,
  },
  {
    title: '短信类型',
    dataIndex: 'type',
    key: 'type',
    width: 120,
    align: 'center',
  },
  {
    title: '发送模板',
    dataIndex: 'contents',
    key: 'contents',
    width: 700,
  },
  {
    title: '参数个数',
    dataIndex: 'paramsNum',
    key: 'paramsNum',
    width: 70,
    align: 'center',
  },
  {
    title: '备注',
    dataIndex: 'memo',
    key: 'memo',
    width: 90,
  },
  {
    title: '来源',
    dataIndex: 'sources',
    key: 'sources',
    width: 80,
    align: 'center',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 120,
  },
  {
    title: '修改时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 120,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: 80,
    align: 'center',
  },
]

export default {
  components: { AddMessageTemple },
  data() {
    return {
      visible: false,
      columns,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      //查询参数
      inputGroup: {
        templeCode: '',
        sources: '',
        messagecontent: '',
        type: '',
      },
      loading: false,
      messageType: [],
      templte: null,
      //短信来源选择器数组
      sourceOpenion: [],
    }
  },
  mounted() {
    //获取列表数据
    this.getTableDate()
  },
  methods: {
    //获取选择器选项
    getMessageTypeOpenion() {
      getMessageType().then((res) => {
        this.messageType = res.result.value
        this.messageType.splice(0, 0, '全部')
      })
    },
    sourceChooseWhat(value) {
      this.inputGroup.sources = value
      this.getTableDateNew()
    },
    //传值给子组件
    testRecord(data) {
      this.templte = data
      this.visible = true
    },
    //修改选择器选择的值
    chooseWhat(value) {
      this.inputGroup.type = value
      this.getTableDateNew()
    },
    //换页执行的方法
    onChange(page, pageSize) {
      this.loading = true
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      let parms = {
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sources: this.inputGroup.sources,
        tempCode: this.inputGroup.templeCode,
        messagecontent: this.inputGroup.messagecontent,
        type: this.inputGroup.type,
        userid: this.$ls.get('Login_Userinfo').id,
      }
      getMessageInfo(parms).then((res) => {
        if (res.success) {
          this.data = res.result.records
          this.pagination.current = res.result.current
          this.pagination.total = res.result.total
        } else {
          this.$message.error('获取数据失败！')
        }
        this.loading = false
      })
    },
    //修改页容量触发方法
    showSizeChange(current, size) {
      this.loading = true
      this.pagination.current = current
      this.pagination.pageSize = size
      let parms = {
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sources: this.inputGroup.sources,
        tempCode: this.inputGroup.templeCode,
        messagecontent: this.inputGroup.messagecontent,
        type: this.inputGroup.type,
        userid: this.$ls.get('Login_Userinfo').id,
      }
      getMessageInfo(parms).then((res) => {
        if (res.success) {
          this.data = res.result.records
          this.pagination.current = res.result.current
          this.pagination.total = res.result.total
        } else {
          this.$message.error('获取数据失败！')
        }
        this.loading = false
      })
    },
    //日期组件
    moment,
    //获取表格数据
    getTableDate() {
      this.loading = true
      let requestParms = {
        id: this.$ls.get('Login_Userinfo').id,
      }
      getSourcesSelecetOpion(requestParms).then((res) => {
        if (res.success) {
          this.sourceOpenion = res.result
          this.sourceOpenion.splice(0, 0, { id: '0000000', sources: '全部' })
          this.inputGroup.sources = this.sourceOpenion[0].sources
          let parms = {
            pageNumber: this.pagination.current,
            pageSize: this.pagination.pageSize,
            sources: this.inputGroup.sources,
            tempCode: this.inputGroup.templeCode,
            messagecontent: this.inputGroup.messagecontent,
            type: this.inputGroup.type,
            userid: this.$ls.get('Login_Userinfo').id,
          }
          getMessageInfo(parms).then((res) => {
            if (res.success) {
              this.data = res.result.records
              this.pagination.current = res.result.current
              this.pagination.total = res.result.total
            } else {
              this.$message.error(res.message)
            }
            this.loading = false
          })
        } else {
          this.$message.error('您没有权限！')
          this.loading = false
        }
      })
    },
    //日期组件修改时触发的方法
    getNewDate(dates, dateStrings) {
      this.loading = true
      this.startDay = dateStrings[0]
      this.endDay = dateStrings[1]
      let parms = {
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sources: this.inputGroup.sources,
        tempCode: this.inputGroup.templeCode,
        messagecontent: this.inputGroup.messagecontent,
        type: this.inputGroup.type,
        userid: this.$ls.get('Login_Userinfo').id,
      }
      getMessageInfo(parms).then((res) => {
        this.data = res.result.records
        this.pagination.current = res.result.current
        this.pagination.total = res.result.total
        this.loading = false
      })
    },
    getTableDateNew() {
      this.loading = true
      let parms = {
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sources: this.inputGroup.sources,
        tempCode: this.inputGroup.templeCode,
        messagecontent: this.inputGroup.messagecontent,
        type: this.inputGroup.type,
        userid: this.$ls.get('Login_Userinfo').id,
      }
      getMessageInfo(parms).then((res) => {
        if (res.success) {
          this.data = res.result.records
          this.pagination.current = res.result.current
          this.pagination.total = res.result.total
        } else {
          console.log(parms)
        }
        this.loading = false
      })
    },
    //关闭抽屉
    onClose() {
      this.visible = false
    },
    //接收模板组件传回的数据
    addTempleResult(data) {
      this.loading = true
      this.visible = data
      let parms = {
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sources: this.inputGroup.sources,
        tempCode: this.inputGroup.templeCode,
        messagecontent: this.inputGroup.messagecontent,
        type: this.inputGroup.type,
        userid: this.$ls.get('Login_Userinfo').id,
      }
      getMessageInfo(parms).then((res) => {
        this.data = res.result.records
        this.pagination.current = res.result.current
        this.pagination.total = res.result.total
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  background-color: #ffffff;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
</style>
